import React from 'react';
import '../PreGame.css';
import { EntryBuildStatus } from '../screens/EntryBuildStatus';

interface PreGameLayoutProps {
  children: React.ReactNode;
}

/**
 * PreGameLayout — Shared full-screen wrapper for all pre-game screens.
 * Provides the dark gradient background, CSS particle field, and
 * centers children with the glass-panel aesthetic.
 */
export const PreGameLayout: React.FC<PreGameLayoutProps> = ({ children }) => (
  <div className="pregame-layout">
    <div className="pregame-bg" />
    <div className="pregame-particles" />
    {children}
    <div className="pregame-version"><EntryBuildStatus /></div>
  </div>
);
